import { render, staticRenderFns } from "./JunoAbout.vue?vue&type=template&id=26b3f786&"
import script from "./JunoAbout.vue?vue&type=script&lang=js&"
export * from "./JunoAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports